import React from 'react';

export function InvitingUserColumnFormatter(cellContent) {
  return (
    <>
      <div className="text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap">
        {cellContent.name}
      </div>
      <div className="text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap">
        {cellContent.agentID}
      </div>
    </>
  );
}
